import { h } from "preact";

import IconProps from "./IconProps";

const DEFAULT_COLOR = "var(--marker-peach)";

function IconGridGapHighlight({
    class: cssClass,
    color
}: IconProps) {
    const fill = color ?? `var(--icon-color, ${DEFAULT_COLOR})`;

    return (
        <svg class={cssClass} width="4" height="4" viewBox="0 0 4 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill={fill} d="M0 0h1.047v4H0z"/>
            <path fill={fill} d="M4 2.5v-1H0v1z"/>
            <path fill={fill} d="M2.952 0h1.047v4H2.952z"/>
        </svg>
    );
}

export default IconGridGapHighlight;

